import React from 'react';

import classNames from 'classnames';

import compose from '../../../../lib/utils/compose';

import {
  withSettings,
  IWithSettingsProps,
} from '../../../../components/context/settings/index';
import { withI18n, IWithI18nProps } from '../../../../components/context/i18n';
import { withTPA, IWithTPAProps } from '../../../../components/context/tpa';

import ErrorIcon from '../../../episode/components/Error/ErrorIcon';

interface IMainPageErrorProps
  extends IWithSettingsProps,
    IWithI18nProps,
    IWithTPAProps {
  error: any;
}

import styles from './Error.scss';
import getStyles from './Error.styles';

function MainPageError({ error, settings, tpa, t }: IMainPageErrorProps) {
  const dynamicStyles = getStyles({
    colors: settings.colors,
    fonts: settings.fonts,
    deviceType: tpa.params.deviceType,
  });

  return (
    <div
      data-hook="main.error"
      className={classNames(styles.errorWrapper, dynamicStyles.errorWrapper)}
    >
      <ErrorIcon
        className={classNames(styles.errorIcon, dynamicStyles.errorIcon)}
      />
      <h2
        data-hook="main.error.title"
        className={classNames(styles.errorTitle, dynamicStyles.errorTitle)}
      >
        {error && error.statusCode === 404
          ? t('pages.main.not-found-title')
          : t('pages.main.unexpected-error-title')}
      </h2>
    </div>
  );
}

export default compose(withI18n, withTPA, withSettings)(MainPageError);
